import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { envTypeGet } from "common/common";
import LoginPage from "components/pages/LoginPage";
import LogoutPage from "components/pages/LogoutPage";
import LoginView from "./LoginView";
import UserGuide from "components/pages/UserGuide";
import { ConfirmDialogProvider } from "common/modal/ConfirmDialog";
import UnosStart from "components/pages/UnosStart";
import VideoList from "components/pages/Video/VideoList";
import VideoNew from "components/pages/Video/VideoNew";
import Video from "components/pages/Video/Video";
import TestPage from "components/pages/TestPage";
import EditView from "./EditView";
import PlayView from "./PlayView";
import PlayPage from "components/pages/PlayPage";
import PanelList from "components/pages/Panel/PanelList/PanelList";
import PanelNew from "components/pages/Panel/PanelNew";
import Panel from "components/pages/Panel/Panel";
import PositionList from "components/pages/Position/PositionList";
import PositionNew from "components/pages/Position/PositionNew";
import Position from "components/pages/Position/Position";
import PlayPanel from "components/pages/PlayPanel";
import TestPlayPanel from "components/pages/TestPlayPanel";
import { WsNotifyContext } from "common/ws/WsNotify";
import { wsInit } from "common/ws/ws_notify";
import { messageReceiveHandle } from "common/ws/ws_message";
import WsnStart from "components/pages/WsnStart";

console.log("envTypeGet: ", envTypeGet(), "apiUrlBaseGet: ");

export default function UnosMainContent() {
  const wsNotifyContextValue = useContext(WsNotifyContext);
  useEffect(() => {
    wsInit(messageReceiveHandle, {
      notifyTime: wsNotifyContextValue.notifyTime,
      setNotifyTime: wsNotifyContextValue.setNotifyTime,
      setConnectionInfo: wsNotifyContextValue.setConnectionInfo,
    });
  }, []);

  return (
    <ConfirmDialogProvider>
      <Router>
        <Routes>
          <Route element={<EditView />}>
            <Route path="/" element={<UnosStart />} />
            <Route path="/video">
              <Route path="list" element={<VideoList />} />
              <Route path="new" element={<VideoNew />} />
              <Route path=":videoId" element={<Video />} />
            </Route>
            <Route path="/panel">
              <Route path="list" element={<PanelList />} />
              <Route path="new" element={<PanelNew />} />
              <Route path=":panelId" element={<Panel />} />
            </Route>
            <Route path="/position">
              <Route path="list" element={<PositionList />} />
              <Route path="new" element={<PositionNew />} />
              <Route path=":positionId" element={<Position />} />
            </Route>
            <Route path="/uputstvo" element={<UserGuide />} />
          </Route>
          <Route element={<LoginView />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<LogoutPage />} />
          </Route>
          <Route element={<PlayView />}>
            <Route path="/play" element={<PlayPage />} />
          </Route>
          <Route path="/play/panel/:panelSlug" element={<PlayPanel />} />
          <Route path="/test-page" element={<TestPage />} />
          <Route path="/test/play/panel" element={<TestPlayPanel />} />
          <Route path="/wsn-test" element={<WsnStart />} />
        </Routes>
      </Router>
    </ConfirmDialogProvider>
  );
}
